/**
 * Cross-domain link helpers for marketing site
 * Marketing site links to app subdomains
 */

export const APP_URL = 'https://app.rooflyzer.pro';
export const AUTH_URL = 'https://auth.rooflyzer.pro';
export const MARKETING_URL = 'https://rooflyzer.pro';

export function getAppLink(path: string): string {
  return `${APP_URL}${path}`;
}

export function getAuthLink(path: string): string {
  return `${AUTH_URL}${path}`;
}

export function getMarketingLink(path: string): string {
  return `${MARKETING_URL}${path}`;
}
